// extracted by mini-css-extract-plugin
export default {"wrap":"top-menu_wrap__ibbSF"};